import { Component } from 'react';
export default class DisketteSave extends Component {
    render() {
        return (
            <svg width="51" height="47" viewBox="0 0 51 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 13.75H32C32.2652 13.75 32.5196 13.8554 32.7071 14.0429C32.8946 14.2304 33 14.4848 33 14.75V30.75C33 31.0152 32.8946 31.2696 32.7071 31.4571C32.5196 31.6446 32.2652 31.75 32 31.75H18C17.7348 31.75 17.4804 31.6446 17.2929 31.4571C17.1054 31.2696 17 31.0152 17 30.75V17.75L21 13.75ZM21 31.75H29V25.75H21V31.75ZM22 17.75H28V13.75H22V17.75Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        )
    }
};